import {
  Close,
  CropSquareOutlined,
  FiberManualRecord,
  LocationOn,
  LocationSearching,
  NearMe,
  PushPin,
  RadioButtonUnchecked,
  Square,
  Star,
  StarBorder,
} from "@mui/icons-material";
import React from "react";

export interface Shapes {
  value:
    | "square-o"
    | "square"
    | "location-arrow"
    | "star-o"
    | "star"
    | "map-pin"
    | "map-marker"
    | "crosshairs"
    | "circle-o"
    | "circle"
    | "cross";
  icon: JSX.Element;
  customizeIcon: (color: string, size: string | number) => JSX.Element;
}

const layerShapes = (): Shapes[] => [
  {
    value: "square-o",
    icon: <CropSquareOutlined fontSize="small" sx={{ padding: "0px" }} />,
    customizeIcon: (color, size) => {
      return (
        <CropSquareOutlined
          sx={{ color: color, fontSize: size, padding: "0px", zIndex: 52 }}
        />
      );
    },
  },
  {
    value: "square",
    icon: <Square fontSize="small" sx={{ padding: "0px" }} />,
    customizeIcon: (color, size) => {
      return (
        <Square
          sx={{ color: color, fontSize: size, padding: "0px", zIndex: 52 }}
        />
      );
    },
  },
  {
    value: "circle",
    icon: <FiberManualRecord fontSize="small" sx={{ padding: "0px" }} />,
    customizeIcon: (color, size) => {
      return (
        <FiberManualRecord
          sx={{ color: color, fontSize: size, padding: "0px", zIndex: 52 }}
        />
      );
    },
  },
  {
    value: "circle-o",
    icon: <RadioButtonUnchecked fontSize="small" sx={{ padding: "0px" }} />,
    customizeIcon: (color, size) => {
      return (
        <RadioButtonUnchecked
          sx={{ color: color, fontSize: size, padding: "0px", zIndex: 52 }}
        />
      );
    },
  },
  {
    value: "location-arrow",
    icon: <NearMe fontSize="small" sx={{ padding: "0px" }} />,
    customizeIcon: (color, size) => {
      return (
        <NearMe
          sx={{ color: color, fontSize: size, padding: "0px", zIndex: 52 }}
        />
      );
    },
  },
  {
    value: "star",
    icon: <Star fontSize="small" sx={{ padding: "0px" }} />,
    customizeIcon: (color, size) => {
      return (
        <Star
          sx={{ color: color, fontSize: size, padding: "0px", zIndex: 52 }}
        />
      );
    },
  },
  {
    value: "star-o",
    icon: <StarBorder fontSize="small" sx={{ padding: "0px" }} />,
    customizeIcon: (color, size) => {
      return (
        <StarBorder
          sx={{ color: color, fontSize: size, padding: "0px", zIndex: 52 }}
        />
      );
    },
  },
  {
    value: "map-marker",
    icon: <LocationOn fontSize="small" sx={{ padding: "0px" }} />,
    customizeIcon: (color, size) => {
      return (
        <LocationOn
          sx={{ color: color, fontSize: size, padding: "0px", zIndex: 52 }}
        />
      );
    },
  },
  {
    value: "map-pin",
    icon: <PushPin fontSize="small" sx={{ padding: "0px" }} />,
    customizeIcon: (color, size) => {
      return (
        <PushPin
          sx={{ color: color, fontSize: size, padding: "0px", zIndex: 52 }}
        />
      );
    },
  },
  {
    value: "crosshairs",
    icon: <LocationSearching fontSize="small" sx={{ padding: "0px" }} />,
    customizeIcon: (color, size) => {
      return (
        <LocationSearching
          sx={{ color: color, fontSize: size, padding: "0px", zIndex: 52 }}
        />
      );
    },
  },
  {
    value: "cross",
    icon: <Close fontSize="small" sx={{ padding: "0px" }} />,
    customizeIcon: (color, size) => {
      return (
        <Close
          sx={{ color: color, fontSize: size, padding: "0px", zIndex: 52 }}
        />
      );
    },
  },
];

export default layerShapes;
